import * as Yup from 'yup';

export const requiredFieldText = 'Campo obrigatório';

export const generalSectionSchema = Yup.object().shape({
  insurance_ans_register: Yup.string().nullable().required(requiredFieldText),
  guide_number: Yup.string().required(requiredFieldText),
  main_guide_number: Yup.string().required(requiredFieldText),
});
